import { render } from "./DoubleRateSlider.vue?vue&type=template&id=5177d4ae&scoped=true"
import script from "./DoubleRateSlider.vue?vue&type=script&lang=js"
export * from "./DoubleRateSlider.vue?vue&type=script&lang=js"

import "./DoubleRateSlider.vue?vue&type=style&index=0&id=5177d4ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5177d4ae"]])

export default __exports__